module.exports = __webpack_public_path__ + "static/media/energy-smart-house-cutout.30876122.webp";